import { useRatingStore } from '@/modules/profile-page/stores/RatingStore';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useSettingsStore = defineStore('settings', () => {
  const isNew = ref(false);
  const offersOnlineAdvice = ref(false);
  const onlineAdviceText = ref('');
  const canReceiveMessages = ref(true);

  const showIsNewBadge = computed(() => isNew.value && useRatingStore().rating.ratingCount === 0);

  return {
    isNew,
    offersOnlineAdvice,
    onlineAdviceText,
    showIsNewBadge,
    canReceiveMessages,
  };
});
